function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "switch",
  transform: "translate(24644 20651)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_27722",
  "data-name": "Rectangle 27722",
  transform: "translate(-24644 -20651)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1,
  opacity: 0
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 19,
  height: 19,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_65368",
  "data-name": "Group 65368",
  transform: "translate(-24643.396 -20649.871)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_65292",
  "data-name": "Group 65292",
  transform: "translate(4.611 3.871)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_70690",
  "data-name": "Path 70690",
  d: "M157.5,226.6l-.883.883L158,228.874h-6.3v1.249H158l-1.387,1.387.883.883,2.894-2.894Z",
  transform: "translate(-150.821 -222.269)",
  fill: "#ff9800"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_70691",
  "data-name": "Path 70691",
  d: "M136.011,109.159h-6.3l1.387-1.387-.883-.883-2.894,2.894,2.894,2.894.883-.883-1.387-1.387h6.3Z",
  transform: "translate(-127.324 -106.889)",
  fill: "#ff9800"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_65293",
  "data-name": "Group 65293",
  transform: "translate(9.25 6.141)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_70692",
  "data-name": "Path 70692",
  d: "M257.463,226.6l-.883.883,1.387,1.387h-2.54v1.249h2.54l-1.387,1.387.883.883,2.894-2.894Z",
  transform: "translate(-255.426 -224.538)",
  fill: "#ff9800"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_27448",
  "data-name": "Rectangle 27448",
  width: 4.048,
  height: 1.249,
  transform: "translate(0)",
  fill: "#ff9800"
}))));

var SvgSwitch = function SvgSwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/switch.70925941.svg";
export { ForwardRef as ReactComponent };